import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './LegalPage.css';


const TermsOfService = () => {
  return (
    <>
      <Header />
      <div className="legal-page">
        <div className="legal-container">
          <Link to="/" className="back-link">← Back to Home</Link>
          
          <h1 className="legal-title">Terms of Service</h1>
          <p className="legal-date">Last Updated: January 27, 2026</p>
          
          <div className="legal-content">
            <p className="legal-intro">
              By accessing or using WhiteLabelDevs services, you agree to these Terms.
            </p>
            
            <section className="legal-section">
              <h2>1. Services</h2>
              <p>We provide Laravel development, React/Next.js development, SaaS development, white-label services, cloud hosting, and managed server services including consulting, design, development, deployment, and maintenance.</p>
            </section>
            
            <section className="legal-section">
              <h2>2. Engagement & Communication</h2>
              <p>Project scope, cost, timeline, and deliverables are finalized via written approval (email, proposal, or contract).</p>
            </section>
            
            <section className="legal-section">
              <h2>3. Payments</h2>
              <ul>
                <li>Advance or milestone payments may be required</li>
                <li>All fees are exclusive of applicable taxes</li>
                <li>Late payments may pause project work</li>
                <li>Hosting services require monthly or annual payment in advance</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>4. Intellectual Property</h2>
              <ul>
                <li>Source code and deliverables belong to the client only after full payment</li>
                <li>We reserve the right to reuse general code libraries, frameworks, and non-confidential components</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>5. Client Responsibilities</h2>
              <p>Client agrees to:</p>
              <ul>
                <li>Provide accurate requirements and timely feedback</li>
                <li>Ensure legal rights to all shared materials</li>
                <li>Review deliverables promptly</li>
                <li>Maintain secure passwords and access credentials for hosting accounts</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>6. Limitation of Liability</h2>
              <p>We are not liable for:</p>
              <ul>
                <li>Business loss, data loss, or indirect damages</li>
                <li>Third-party service failures (infrastructure providers, APIs)</li>
                <li>Misuse of delivered software</li>
                <li>Data breaches caused by client's own code vulnerabilities</li>
              </ul>
              <p>Maximum liability is limited to the amount paid for services.</p>
            </section>
            
            <section className="legal-section">
              <h2>7. Termination</h2>
              <p>Either party may terminate with written notice. Payments for completed work remain due.</p>
            </section>
            
            <section className="legal-section">
              <h2>8. Governing Law</h2>
              <p>These terms are governed by the laws of India.</p>
            </section>
          </div>
          
          <div className="legal-footer">
            <p><strong>VIDYADHAR GLOBAL AI INNOVATIONS PRIVATE LIMITED</strong></p>
            <p>Operating as: WhiteLabelDevs</p>
            <p>CIN: U62090UP2026PTC241378</p>
            <p>2 Maa Pitambara Complex, Dwarika Green Phase 2, Agra Bamroli Road, UP 282009</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsOfService;